import React from 'react';
import DashboardCards from './DashboardCards';
import DashboardGraphs from './DashboardGraphs';

const Dashboard = () => {
    return (
        <>
            <DashboardCards />
            <DashboardGraphs />
        </>
    );
};

export default Dashboard;
